import { RootState } from "../../RootReducer";

export const selectForeground = (state: RootState) => state.application.foreground;
export const selectPreviousForeground = (state: RootState) => state.application.previousForeground;
export const selectRetryAction = (state: RootState) => state.application.retryAction;
export const selectLoginAnalyticsInfo = (state: RootState) => state.application.loginAnalyticsInfo;
